// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/switch-to-standard-bank/switch-to-standard-bank.component.scss
// module id = 161
// module chunks = 0